import { useEffect, useRef, useState } from "react";
import FilterComponent from "../../../components/comman/FilterComponent";
import MainHeading from "../../../components/comman/MainHeading";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import CommonTable from "../../../components/comman/CommonTable";
import ViewIcon from "../../../components/Icons/ViewIcon";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { useDispatch, useSelector } from "react-redux";
import EditIcon from "../../../components/Icons/EditIcon";
import ConfirmModal from "../../../components/comman/ConfirmModal";
import { toast } from "react-toastify";
import DeleteIcon from "../../../components/Icons/DeleteIcon";
import {
  Nav,
  NavItem,
  NavLink,
  Spinner,
  TabContent,
  Fade,
  TabPane,
} from "reactstrap";
import {
  saveActivePurchaseRequestTab,
  updateFiltersStates,
} from "../../../store/actions/UserActions";
import ExportDataHandler from "../../../utility/ExportDataHandler";

export default function PurchaseRequest() {
  const [state, setState] = useState({
    purchaseRequestList: [],
    siteList: [],
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state.root.userDetails);
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [selectedId, setSelectedId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isFirstYearChange, setIsFirstYearChange] = useState(true);
  const ActiveTab = useSelector(
    (state) => state?.root?.activePurchaseRequestTab
  );
  const [pageStates, setPageStates] = useState({
    searchQuery: "",
    tableLoader: false,
    user: "",
    status:
      ActiveTab == 1
        ? "pending"
        : ActiveTab == 2
        ? "approved"
        : ActiveTab == 4
        ? "hold"
        : ActiveTab == 3
        ? "rejected"
        : "",
        siteId: filterDetails?.siteId,
    siteList: [],
    companyList: [],
    companyIsLoading: false,
    isLoadingSite: false,
    isInitial: true,
  });
  const timeoutId = useRef(null);

  useEffect(() => {
    if (filterDetails?.year) {
      GetPurchaseRequest();
    }
  }, [
    filterDetails?.currentPage,
    filterDetails?.pageSize,
    pageStates?.searchQuery,
    filterDetails?.sortByDate,
    filterDetails?.year,
    filterDetails?.siteId,
    pageStates?.status,
    filterDetails?.companyId,
    filterDetails?.requestType,
    filterDetails?.orderBy,
    pageStates?.isInitial,
  ]);

  useEffect(() => {
    GetCompanyList();
  }, []);

  useEffect(() => {
    GetSiteList(filterDetails?.companyId);
  }, [filterDetails?.companyId]);

  // printData("FilterData>>", filterDetails)

  const GetPurchaseRequest = (pageNo) => {
    let options = {
      method: "GET",
    };
    const filterData = {
      status: pageStates?.status,
      searchQuery: pageStates?.searchQuery,
      siteId: pageStates?.siteId,
      ...filterDetails,
    };
    const Url =
      apiUrl.get_purchase_request + "?" + MainFilterHandler(filterData);
    setPageStates((pre) => ({
      ...pre,
      tableLoader: !pre.tableLoader,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: !pre.tableLoader,
      }));
      if (res?.status === true) {
        const newData = res?.data?.purchaseRequest?.map((item) => ({
          ...item,
          createdOn: moment(item?.date).format("DD-MM-YYYY") || "--",
          expDate: moment(item?.expectedDate).format("DD-MM-YYYY") || "--",
          siteName: item?.site?.name,
          person: item?.user?.name,
          purchaseRequestStatus: item?.status,
          reqType:
            item?.type === "supplyRequest"
              ? "Supply Request"
              : "Service Request",
        }));
        setState((pre) => ({
          ...pre,
          purchaseRequestList: newData,
        }));
        dispatch(
          updateFiltersStates({
            count: res?.data?.pageInfo?.total,
            totalPages: res?.data?.pageInfo?.totalPages,
          })
        );
      }
    });
  };

  const GetCompanyList = (inputValue) => {
    return new Promise((resolve) => {
      let API = `${apiUrl.get_company}${
        inputValue ? `?search=${inputValue}` : ""
      }`;
      let options = { method: "GET" };
      setPageStates((prev) => ({
        ...prev,
        companyIsLoading: true,
      }));
      callApi(API, options)
        .then((response) => {
          if (response?.status) {
            const formattedData = response?.data?.company.map((company) => ({
              value: company.id,
              label: company.name,
            }));

            setPageStates((prev) => ({
              ...prev,
              companyIsLoading: false,
              companyList: formattedData,
            }));
            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          resolve([]);
        });
    });
  };

  const toggleTab = (tab) => {
    dispatch(saveActivePurchaseRequestTab(tab));
    setPageStates((prev) => ({
      ...prev,
      status:
        tab == 1
          ? "pending"
          : tab == 2
          ? "approved"
          : tab == 4
          ? "hold"
          : tab == 3
          ? "rejected"
          : "",
    }));
    dispatch(
      updateFiltersStates({
        currentPage: 1,
        companyId: "",
        pageSize: 10,
      })
    );
    if (state?.siteList?.length == 0) {
      GetSiteList();
    }
  };

  const HandleView = (data) => {
    navigate(RoutesLink.purchase_request_detail + `/${data?.id}`);
  };

  const HandleUpdate = (data) => {
    navigate(RoutesLink?.create_purchase_request, {
      state: { EditData: data },
    });
  };

  const ActionHandler = (data) => {
    setSelectedId(data?.id);
    toggle();
  };

  const HandleDelete = () => {
    let options = {
      method: "GET",
    };
    let API =
      apiUrl.delete_purchase_request + `?purchaseRequestId=${selectedId}`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        toggle();
        GetPurchaseRequest(filterDetails?.currentPage);
      } else {
        toast.error(response?.message);
        toggle();
      }
    });
  };

  const TableHeading = [
    { value: "requestNumber", label: "Request No." },
    { value: "createdOn", label: "Created At" },
    { value: "expDate", label: "Expected At" },
    { value: "siteName", label: "Site Name" },
    { value: "person", label: "Created By" },
    { value: "reqType", label: "Type" },
    { value: "purchaseRequestStatus", label: "Status" },
  ];

  const ActionData = [
    {
      label: "View",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleView,
    },
  ];

  const ActionDataForPending = [
    {
      label: "View",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleView,
    },
    ...(!(
      userDetails?.type === 2 ||
      userDetails?.designation?.name === "Coordinator"
    )
      ? [
          {
            label: "Update",
            className: "btn btn-link",
            icon: <EditIcon />,
            title: "update",
            clickHandler: HandleUpdate,
          },
        ]
      : []),
    {
      label: "Delete",
      className: "btn btn-link",
      icon: <DeleteIcon />,
      title: "delete",
      isShow: false,
      isSiteEditable: false,
      isVisible: "pending",
      type: userDetails?.type,
      loggedInUserId: userDetails?.id,
      clickHandler: ActionHandler,
    },
  ];

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      dispatch(updateFiltersStates({ currentPage: 1 }));
      setPageStates((prevState) => ({
        ...prevState,
        searchQuery: value,
      }));
    }, 300);
  };

  const dateChangeHandler = (Dates) => {
    // console.log(Dates);
    let formattedDate = null;
    if (Dates && Dates.length === 2) {
      const startDate = new Date(
        Dates[0].getTime() - Dates[0].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      const endDate = new Date(
        Dates[1].getTime() - Dates[1].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      formattedDate = [startDate, endDate];
    }
    // console.log(formattedDate);
    if (formattedDate !== null) {
      dispatch(
        updateFiltersStates({
          sortByDate: formattedDate,
        })
      );
    } else {
      dispatch(
        updateFiltersStates({
          sortByDate: "",
        })
      );
    }
  };

  const PageChangeHandler = (PageNo) => {
    // console.log("PageChangeHandler", PageNo);
    if (PageNo > 0 && PageNo <= filterDetails?.totalPages) {
      dispatch(
        updateFiltersStates({
          currentPage: PageNo,
        })
      );
    }
  };

  const handleChangePageSize = (value) => {
    dispatch(
      updateFiltersStates({
        currentPage: 1,
        pageSize: value,
      })
    );
  };

  const GetSiteList = (companyId = null, searchQuery = null) => {
    return new Promise((resolve) => {
      let API =
        userDetails?.type === 2
          ? apiUrl.get_site +
            `?pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}${
              searchQuery ? `&search=${searchQuery}` : ""
            }`
          : apiUrl.get_user_site +
            `?pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}${
              searchQuery ? `&search=${searchQuery}` : ""
            }`;

      setPageStates((prev) => ({
        ...prev,
        isLoadingSite: true,
      }));

      callApi(API, { method: "GET" })
        .then((response) => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));

          if (response?.status) {
            const formattedData = response.data?.site?.map((item) => ({
              value: item?.site?.id || item.id,
              label: item?.site?.name || item.name,
            }));

            const isSitePresent = response.data?.site?.some((item) => {
              const id = item?.site?.id || item.id;
              return id == filterDetails?.siteId;
            });

            setPageStates((prev) => ({
              ...prev,
              ...(isSitePresent ? { isInitial: false } : { siteId: "" }),
              siteList: formattedData || [],
            }));

            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));
          resolve([]);
        });
    });
  };

  const sortList = {
    site: pageStates?.siteList,
    isShow: "allNotshow",
    companyList: pageStates?.companyList,
  };

  const handleData = (data, type) => {
    setPageStates((prevState) => ({
        ...prevState,
        ...(type === "site" && { siteId: data?.site }),
        ...(type === "companyId" && { companyId: data?.companyId }),
        ...(type == "companyId" && {
          siteId: "",
        }),
      }));
    dispatch(
      updateFiltersStates({
        ...(type === "site" && { siteId: data?.site }),
        ...(type == "companyId" && { companyId: data?.companyId, siteId: "" }),
        ...(type == "requestType" && { requestType: data?.requestType }),
      })
    );
  };

  const handleYearChange = (selectedYear) => {
    dispatch(
      updateFiltersStates({
        year: selectedYear,
        sortByDate: isFirstYearChange ? filterDetails.sortByDate : [],
      })
    );
    if (isFirstYearChange) {
      setIsFirstYearChange(false);
    }
  };

  const handleExport = () => {
    const filterData = {
      exportDataType: "purchaseRequest",
      status: pageStates?.status,
      searchQuery: pageStates?.searchQuery,
      ...filterDetails,
    };
    delete filterData?.currentPage;
    delete filterData?.pageSize;
    delete filterData?.count;
    delete filterData?.totalPages;
    ExportDataHandler(filterData);
  };

  const orderByHandler = (e) => {
    dispatch(
      updateFiltersStates({
        orderBy: e.target.value,
      })
    );
  };

  const orderByList = [
    { value: "", name: "Newest" },
    { value: "asc", name: "Oldest" },
  ];

  return (
    <>
      <>
        <div className="content">
          <MainHeading
            title={"Purchase Requests"}
            buttonText={
              userDetails?.designation?.canCreate?.includes("pr") &&
              "Create Purchase Request"
            }
            buttonLink={
              userDetails?.designation?.canCreate?.includes("pr") &&
              RoutesLink?.create_purchase_request
            }
            dateChangeHandler={dateChangeHandler}
            handleYearChange={handleYearChange}
          />
          <Nav tabs className="nav nav-tabs border-0 mb-4">
            <NavItem className="nav-item ">
              <NavLink
                className={
                  ActiveTab === 1
                    ? "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0  border-end-1 border-start-1 active"
                    : "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-1 border-start-1"
                }
                style={{ cursor: "pointer" }}
                onClick={() => toggleTab(1)}
                disabled={pageStates?.tableLoader}
              >
                Pending
              </NavLink>
            </NavItem>
            <NavItem className="nav-item ">
              <NavLink
                className={
                  ActiveTab === 2
                    ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-1 border-start-0 active"
                    : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-1 border-start-0"
                }
                style={{ cursor: "pointer" }}
                onClick={() => toggleTab(2)}
                disabled={pageStates?.tableLoader}
              >
                Approved
              </NavLink>
            </NavItem>
            <NavItem className="nav-item ">
              <NavLink
                className={
                  ActiveTab === 4
                    ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-1 border-start-0 active"
                    : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-1 border-start-0"
                }
                style={{ cursor: "pointer" }}
                onClick={() => toggleTab(4)}
                disabled={pageStates?.tableLoader}
              >
                Hold
              </NavLink>
            </NavItem>
            <NavItem className="nav-item ">
              <NavLink
                className={
                  ActiveTab === 3
                    ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0 active"
                    : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0"
                }
                style={{ cursor: "pointer" }}
                onClick={() => toggleTab(3)}
                disabled={pageStates?.tableLoader}
              >
                Rejected
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={ActiveTab}>
            <TabPane tabId={1}>
              <Fade in={ActiveTab === 1} timeout={200}>
                <div className="card">
                  <div className="card-body">
                    <FilterComponent
                      handleSearch={handleSearchChange}
                      searchPlaceHolder={"Search By Request No."}
                      filterArray={sortList}
                      typeFilter={true}
                      handleData={handleData}
                      pageStates={pageStates}
                      handleExport={
                        state?.purchaseRequestList?.length > 0
                          ? handleExport
                          : null
                      }
                      orderByHandler={orderByHandler}
                      orderByList={orderByList}
                      getCompany={GetCompanyList}
                    />
                    <CommonTable
                      TableHeading={TableHeading}
                      TableData={state?.purchaseRequestList}
                      PageChangeHandler={PageChangeHandler}
                      ActionData={ActionDataForPending}
                      currentPage={filterDetails?.currentPage}
                      isLoading={pageStates?.tableLoader}
                      totalPages={filterDetails?.totalPages}
                      count={filterDetails?.count}
                      pageSize={filterDetails.pageSize}
                      handleChangePageSize={handleChangePageSize}
                    />
                  </div>
                </div>
              </Fade>
            </TabPane>
            <TabPane tabId={2}>
              <Fade in={ActiveTab === 2} timeout={200}>
                <div className="card">
                  <div className="card-body">
                    <FilterComponent
                      handleSearch={handleSearchChange}
                      searchPlaceHolder={"Search By Request No."}
                      filterArray={sortList}
                      typeFilter={true}
                      handleData={handleData}
                      pageStates={pageStates}
                      handleExport={
                        state?.purchaseRequestList?.length > 0
                          ? handleExport
                          : null
                      }
                      orderByHandler={orderByHandler}
                      orderByList={orderByList}
                      getSite={GetSiteList}
                      getCompany={GetCompanyList}
                    />
                    <CommonTable
                      TableHeading={TableHeading}
                      TableData={state?.purchaseRequestList}
                      ActionData={ActionData}
                      currentPage={filterDetails?.currentPage}
                      PageChangeHandler={PageChangeHandler}
                      isLoading={pageStates?.tableLoader}
                      totalPages={filterDetails?.totalPages}
                      count={filterDetails?.count}
                      handleChangePageSize={handleChangePageSize}
                      pageSize={filterDetails.pageSize}
                    />
                  </div>
                </div>
              </Fade>
            </TabPane>
            <TabPane tabId={4}>
              <Fade in={ActiveTab === 4} timeout={200}>
                <div className="card">
                  <div className="card-body">
                    <FilterComponent
                      handleSearch={handleSearchChange}
                      searchPlaceHolder={"Search By Request No."}
                      filterArray={sortList}
                      typeFilter={true}
                      handleData={handleData}
                      pageStates={pageStates}
                      handleExport={
                        state?.purchaseRequestList?.length > 0
                          ? handleExport
                          : null
                      }
                      orderByHandler={orderByHandler}
                      orderByList={orderByList}
                      getSite={GetSiteList}
                      getCompany={GetCompanyList}
                    />
                    <CommonTable
                      TableHeading={TableHeading}
                      TableData={state?.purchaseRequestList}
                      ActionData={ActionData}
                      currentPage={filterDetails?.currentPage}
                      PageChangeHandler={PageChangeHandler}
                      isLoading={pageStates?.tableLoader}
                      totalPages={filterDetails?.totalPages}
                      count={filterDetails?.count}
                      handleChangePageSize={handleChangePageSize}
                      pageSize={filterDetails.pageSize}
                    />
                  </div>
                </div>
              </Fade>
            </TabPane>
            <TabPane tabId={3}>
              <Fade in={ActiveTab === 3} timeout={200}>
                <div className="card">
                  <div className="card-body">
                    <FilterComponent
                      handleSearch={handleSearchChange}
                      searchPlaceHolder={"Search By Request No."}
                      filterArray={sortList}
                      typeFilter={true}
                      handleData={handleData}
                      pageStates={pageStates}
                      handleExport={
                        state?.purchaseRequestList?.length > 0
                          ? handleExport
                          : null
                      }
                      orderByHandler={orderByHandler}
                      orderByList={orderByList}
                      getSite={GetSiteList}
                      getCompany={GetCompanyList}
                    />
                    <CommonTable
                      TableHeading={TableHeading}
                      TableData={state?.purchaseRequestList}
                      ActionData={ActionData}
                      isLoading={pageStates?.tableLoader}
                      currentPage={filterDetails?.currentPage}
                      PageChangeHandler={PageChangeHandler}
                      totalPages={filterDetails?.totalPages}
                      count={filterDetails?.count}
                      handleChangePageSize={handleChangePageSize}
                      pageSize={filterDetails?.pageSize}
                    />
                  </div>
                </div>
              </Fade>
            </TabPane>
          </TabContent>
        </div>
      </>
      <ConfirmModal
        modal={modal}
        toggle={toggle}
        submitHandler={HandleDelete}
        isLoading={isLoading}
      />
    </>
  );
}
